import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MenuContextService } from '../../layout/services/menu-context.service';
import { MenuExpandContextService } from '../../layout/services/menu-expand-context.service';
import { ScreenService } from '../services/screen.service';
import { ShelfService } from '../../spots/services/shelf.service';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { environment } from '../../../../environments/environment';
import { FormControl } from '../../../helpers/crud/edit/form-control/form-control.model';
import { MatDialog } from '@angular/material/dialog';
import { SeeSelectedScreenComponent } from '../see-selected-screen/see-selected-screen.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../services/alert/alert.service';
import { DatePipe } from '@angular/common';
import { SelectFaceFromMapOutput } from '../map-item/map-item.component';
import { FilterResult } from '../../../helpers/crud/repository.service';
import { debounceTime, map } from 'rxjs/operators';
import { GoogleAddressService } from '../../../services/google-address/google-address.service';
import {
    MarkerItem,
    ScreenForList,
    InputFilter,
    ScreenMap,
    FaceMap,
} from '../model/store.model';
import { HttpErrorResponse } from '@angular/common/http';
import { TitleService } from '../../../services/title/title.service';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { fromEvent } from 'rxjs';
import { DateTime } from 'luxon';
import { CartEditParam } from '../cart/cart.component';
import { Crisp } from 'crisp-sdk-web';
import { UserAuthService } from '../../../services/user/user-auth.service';
import { LatLng } from 'leaflet';
import { OrderService } from '../services/order.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
declare const fbq: any;
@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
    animations: [
        trigger('textFade', [
            state('void', style({ opacity: 0 })),
            state('*', style({ opacity: 1 })),
            transition('void => *', [animate('0.2s 0.2s ease-in')]),
            transition('* => void', [animate('0.2s ease-in')])
        ])
    ],
})
export class MapComponent implements OnInit {
    // #region Variables
    @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;
    @ViewChild(GoogleMap, { static: false }) map: google.maps.Map;
    @ViewChild('campaignNameInput') campaignNameInput: any;
    @ViewChild('dateInput') dateInput: ElementRef;

    /**
     * Points de la carte
     */
    public markers: MarkerItem[] = [];

    /**
     * Coordonnées du centre de la carte, par défaut la France
     */
    public center = { lat: 46.362301586334988, lng: 2.5612295000000813 };
    /**
     * Options de la carte
     */
    public mapOptions: google.maps.MapOptions = {
        // center: { lat: 46.362301586334988, lng: 2.5612295000000813 }, //Center France by default
        disableDefaultUI: true,
        gestureHandling: 'greedy',
        zoom: 8,
        styles: [
            { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
            { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            {
                elementType: 'labels.text.fill',
                stylers: [{ color: '#616161' }],
            },
            {
                elementType: 'labels.text.stroke',
                stylers: [{ color: '#f5f5f5' }],
            },
            {
                featureType: 'administrative.land_parcel',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#bdbdbd' }],
            },
            {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [{ color: '#eeeeee' }],
            },
            {
                featureType: 'poi',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#757575' }],
            },
            {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [{ color: '#e5e5e5' }],
            },
            {
                featureType: 'poi.park',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#9e9e9e' }],
            },
            {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [{ color: '#ffffff' }],
            },
            {
                featureType: 'road.arterial',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#757575' }],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [{ color: '#dadada' }],
            },
            {
                featureType: 'road.highway',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#616161' }],
            },
            {
                featureType: 'road.local',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#9e9e9e' }],
            },
            {
                featureType: 'transit.line',
                elementType: 'geometry',
                stylers: [{ color: '#e5e5e5' }],
            },
            {
                featureType: 'transit.station',
                elementType: 'geometry',
                stylers: [{ color: '#eeeeee' }],
            },
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{ color: '#c9c9c9' }],
            },
            {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#9e9e9e' }],
            },
        ],
        clickableIcons: false,
    };
    public locationInformation?: ScreenForList = null;
    /**
     * Latitude courante de l'utilisateur sur la carte
     */
    public userLat?: number = null;
    /**
     * Longitude courante de l'utilisateur sur la carte
     */
    public userLon?: number = null;
    baseUrl: string;

    // For InfiniteScroll
    windowHeight: number;
    window: Window;
    listHeight: number;
    pageSizeOptions = [10, 25, 100];
    total$: any;
    alreadyCalled = false;
    public addressLat: any = null;
    public addressLng: any = null;
    /**
     * SelectedFaceIds
     */
    public selectedFaceIds: number[] = [];
    /**
     * Liste de tous les écrans (liste de gauche)
     */
    public screenList: ScreenForList[] = [];

    /**
     * Nom de la campagne utilisateur
     */
    public campaignName: FormControl;
    /**
     * Recherche de l'adresse
     */
    public locationSearch: FormControl;
    public locationOptions = [];
    /**
     * Date du jour
     */
    public today = new Date();
    /** Date minimale de campagne (today par default) */
    // public minDate = this.today;
    /**
     * Date de début de la campagne - [LUXON](https://moment.github.io/luxon/#/?id=luxon)
     */
    public startDate: FormControl;
    /**
     * Date de fin de la campagne - [LUXON](https://moment.github.io/luxon/#/?id=luxon)
     */
    public endDate: FormControl;

    public showRecap: boolean = false;
    public selectedFaceInfo: ScreenForList[] = null;

    public canNext = false;
    public nextText = 'Selectionner au moins un écran';
    public screenFilter = new InputFilter();
    /**
     * Marker sélectionné actuellement - nullable
     * @nullable
     */
    public selectedMapMarker?: MapMarker = null;

    public isSelectionOK: boolean = true;

    /**
     * Durée d'apparition des snackBars (en Ms) d'erreur dans ce component
     */
    private readonly errorSnackDurationMs = 1700;

    /**
     * Durée du délai (en Ms) avant de recharger la map après un drag
     */
    private readonly MapDragDebounceTimeMs = 700;

    public displayMap = false;
    public displayList = true;
    public mobile = false;
    /**
     * Durée avant de stopper le bouncing sur un Pin dans la carte en millisecondes
     */
    private readonly bouncingMarkerTimeoutMs = 3000;

    public isDeviceIsDesktop: boolean = false;

    /**
     * Toggle si true, mode spécial sur la sélection d'un écran
     */
    private isMultipleScreenSelection: boolean = false;

    public isScreenListLoading: boolean = false;

    /** Lien vers les markers de la map **/

    private readonly PinkFilledMkr =
        'https://wancomresource.s3.eu-west-3.amazonaws.com/markerPinkFilled.png';

    private readonly BlueFilledMkr =
        'https://wancomresource.s3.eu-west-3.amazonaws.com/markerBlueFilled.png';

    private readonly InactiveStrokedMkr =
        'https://wancomresource.s3.eu-west-3.amazonaws.com/markerInactiveStrocked.png';

    private readonly PinkStrokedMkr =
        'https://wancomresource.s3.eu-west-3.amazonaws.com/markerPinkStrocked.png';

    private readonly BlueStrokedMkr =
        'https://wancomresource.s3.eu-west-3.amazonaws.com/markerBlueStrocked.png';

    private readonly BlueHalfFilledMkr =
        'https://wancomresource.s3.eu-west-3.amazonaws.com/markerBlueFilledHalf.png';

    private readonly PinkHalfFilledMkr =
        'https://wancomresource.s3.eu-west-3.amazonaws.com/markerPinkFilledHalf.png';
    private readonly PinkFilledAndInactiveHalfMkr =
        'https://wancomresource.s3.eu-west-3.amazonaws.com/markerPinkFilledAndInactiveHalf.png';
    public cartPriceHT: number = null;
    //#endregion Variables

    //MARK: Constructor
    constructor(
        private menuContext$: MenuContextService,
        private menuExpandContext$: MenuExpandContextService,
        public screen$: ScreenService,
        public shelf$: ShelfService,
        private router: Router,
        private dialog: MatDialog,
        private alert$: AlertService,
        public datePipe: DatePipe,
        public title$: TitleService,
        private waiting$: WaitingService,
        private route: ActivatedRoute,
        private userAuth$: UserAuthService,
        private readonly order$: OrderService,
        public google?: GoogleAddressService,
    ) {
        this.baseUrl = environment.apiBaseUrl;

        this.window = <Window>window;

        this.windowHeight = this.window.innerHeight;
        this.resizeWorks();
        setTimeout(() => {
            this.title$.next('Store');
        }, 0);
    }

    async ngOnInit(): Promise<void> {
        if (window.screen.width <= 900) {
            // 768px portrait
            this.mobile = true;
        }
        //Init ScreenFilter
        this.screenFilter.pageSize = 20;
        this.screenFilter.page = 0;

        //Init geolocation
        navigator.geolocation.getCurrentPosition((position) => {
            this.userLon = position.coords.longitude;
            this.userLat = position.coords.latitude;
            this.mapOptions.center = { lat: this.userLat, lng: this.userLon };
        });
        this.getLocation();

        //Init Menu
        this.menuContext$.next(true);
        this.menuExpandContext$.next(false);

        //Init form
        this.campaignName = new FormControl('campaignName');
        this.locationSearch = new FormControl('locationSearch');
        this.startDate = new FormControl('startDate');
        this.endDate = new FormControl('endDate');

        //Get Dates from localStorage
        if (
            localStorage.getItem('campaignStartDate') != null ||
            localStorage.getItem('campaignEndDate') != null
        ) {
            this.initDatesFromLocalStorage();
            this.loadScreenMaps(
                this.endDate.value || null,
                this.startDate.value || null
            );
        } else {
            this.loadScreenMaps();
        }

        this.campaignName.valueChanges.pipe(debounceTime(1000)).subscribe(() => {
            localStorage.setItem('campaignName', this.campaignName.value);
            if (this.window && this.window.dataLayer != null) {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'campagne_nommee',
                });
                fbq('track', 'campagne_nommee', {});
            } else {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'campagne_nommee',
                });
                fbq('track', 'campagne_nommee', {});
            }
            this.checkCanNext();
        });

        //Adresse
        this.locationSearch.valueChanges.subscribe(() => {
            this.locationOptions = [];

            if (this.locationSearch.value !== 'Selon carte') {
                this.addressLat = null;
                this.addressLng = null;
                if (
                    this.locationSearch.value != null &&
                    this.locationSearch.value !== ''
                ) {
                    const addressAutoComplete =
                        new google.maps.places.AutocompleteService();

                    addressAutoComplete.getPlacePredictions(
                        {
                            input: this.locationSearch.value,
                            componentRestrictions: { country: 'fr' },
                        },
                        (predictions, status) => {
                            this.locationOptions = [];
                            if (status === 'OK') {
                                predictions.forEach((prediction) => {
                                    this.locationOptions.push(
                                        prediction['description']
                                    );
                                });
                            }
                        }
                    );
                }
            }
        });

        if (localStorage.getItem('campaignName') != null) {
            this.campaignName.setValue(localStorage.getItem('campaignName'));
        }

        // SelectedFace
        if (
            localStorage.getItem('selectedFace') != null &&
            localStorage.getItem('selectedFace') !== ''
        ) {
            this.selectedFaceIds = localStorage
                .getItem('selectedFace')
                .split(',')
                .map(Number);

            if (this.screenList != null) {
                this.checkIfFaceSelected();
            }
        }
        this.InitMapDrag();
        this.checkForWarnings();
        this.checkCanNext();
        this.initQueryParams();
        this.LoadCartPrice();
        
        if (window.innerWidth <= 900) {
            this.isDeviceIsDesktop = false;
        } else {
            this.isDeviceIsDesktop = true;
        }
        if (!Crisp.isCrispInjected()) {
            Crisp.configure('7d4a0471-984f-4f44-a5cd-e0ef1ef779b4');
            Crisp.chat.show();
            if(!this.isDeviceIsDesktop){
                Crisp.chat.hide();
            }
        } else {
            Crisp.chat.show();
            if(!this.isDeviceIsDesktop){
                Crisp.chat.hide();
            }
        }

        this.total$ = this.screen$.pipe(map((d) => d.total));
    }

    ngOnDestroy(): void {
        Crisp.chat.hide();
    }

    /**
     * Gère et instancie les paramètres dans l'URL
     */
    private initQueryParams() {
        this.route.queryParams.subscribe((p) => {
            switch (parseInt(p.e)) {
                case CartEditParam.Name:
                    setTimeout(() => {
                        this.focusCampaignName();
                    }, 0);

                    break;
                case CartEditParam.Dates:
                    setTimeout(() => {
                        this.focusCampaignDate();
                    }, 0);
                    break;

                case CartEditParam.Screens:
                    this.goToRecap();
                    break;
                default:
                    break;
            }

            //cn = CampaignName
            if (p.cn != null && p.cn !== 'null' && p.cn !== 'undefined') {
                this.campaignName.setValue(p.cn);
            }

            if (p.sd) {
                if (DateTime.fromISO(p.sd).toISODate() != null) {
                    this.startDate.setValue(DateTime.fromISO(p.sd), {
                        emitEvent: false,
                    });
                } else {
                    console.warn(
                        "Date de début passée dans l'URL incorrecte - La date doit être au format ISO 8601 : yyyy-MM-dd"
                    );
                }
            }

            if (p.ed) {
                if (DateTime.fromISO(p.ed).toISODate() != null) {
                    this.endDate.setValue(DateTime.fromISO(p.ed), {
                        emitEvent: false,
                    });
                } else {
                    console.warn(
                        "Date de fin passée dans l'URL incorrecte - La date doit être au format ISO 8601 : yyyy-MM-dd"
                    );
                }
            }
            if (p.ad) {
                if (p.ad != null && p.ad !== '') {
                    this.locationSearch.setValue(p.ad);

                    const addressAutoComplete =
                        new google.maps.places.AutocompleteService();
                    addressAutoComplete.getPlacePredictions(
                        {
                            input: p.ad,
                            componentRestrictions: { country: 'fr' },
                        },
                        (predictions, status) => {
                            this.locationOptions = [];
                            if (status === 'OK') {
                                predictions.forEach((prediction) => {
                                    this.locationOptions.push(
                                        prediction['description']
                                    );
                                });
                            }
                            let elementDom = document.getElementById(
                                'locationSearchInput'
                            );
                            elementDom.focus();
                            elementDom.click();
                        }
                    );
                }
            }
        });
    }

    /**
     * Initialise et gère le drag sur la map (avec un debounceTime)
     */
    private InitMapDrag() {
        const mapDragEvent = fromEvent(
            document.getElementById('map'),
            'dragend'
        ).pipe(debounceTime(this.MapDragDebounceTimeMs));

        mapDragEvent.subscribe(() => {
            this.onDrag(true);
        });
    }

    /**
     *
     * @param elementId Id de l'élément
     * @param eventName Nom de l'évênement
     */
    public triggerEvent(elementId: string, eventName: string) {
        document.getElementById(elementId).dispatchEvent(new Event(eventName));
    }

    /**
     *
     * Set La date de début et de fin enregistrée dans le localStorage
     */
    private initDatesFromLocalStorage() {
        //Start Date
        let startDateLocal: any = localStorage.getItem('campaignStartDate');
        startDateLocal = this.datePipe.transform(startDateLocal, 'MM dd, yyyy');

        if (startDateLocal != null) {
            startDateLocal = DateTime.fromJSDate(new Date(startDateLocal));

            if (startDateLocal < DateTime.now().startOf('day')) {
                startDateLocal = DateTime.now().startOf('day');
                localStorage.setItem('campaignStartDate', startDateLocal);
            }
        }
        this.startDate.setValue(startDateLocal);

        //End Date
        let endDateLocal: any = localStorage.getItem('campaignEndDate');
        endDateLocal = this.datePipe.transform(endDateLocal, 'MM dd, yyyy');

        if (endDateLocal != null) {
            endDateLocal = DateTime.fromJSDate(new Date(endDateLocal));

            if (endDateLocal < DateTime.now().startOf('day')) {
                endDateLocal = DateTime.now().startOf('day');
                localStorage.setItem('campaignEndDate', endDateLocal);
            }
        }
        this.endDate.setValue(endDateLocal);
    }

    /**
     * Tente de récupérer la position GPS et charge la liste des écrans autour
     */
    getLocation() {
        const waitingId: string = this.waiting$.start();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position: GeolocationPosition) => {
                    this.userLon = position.coords.longitude;
                    this.userLat = position.coords.latitude;
                    this.screenFilter.page = 0;
                    //Get screen for screenList
                    this.loadScreenList(waitingId);
                },
                (err) => {
                    //Position désactivée sur la navigateur de l'utilisateur
                    this.screenFilter.page = 0;
                    //Get screen for screenList
                    this.loadScreenList(waitingId);
                }
            );
        } else {
            console.error('No support for geolocation');
        }
    }

    /**
     * charge la liste des écrans de gauche
     * @param waitingId waiting Id pour le chargement
     */
    private loadScreenList(waitingId: string) {
        this.isScreenListLoading = true;
        this.screen$
            .getScreenList(
                this.userLat,
                this.userLon,
                null,
                this.screenFilter,
                {
                    startDate: this.startDate?.value,
                    endDate: this.endDate?.value,
                }
            )
            .subscribe({
                next: (res: FilterResult<ScreenForList>) => {
                    this.waiting$.end(waitingId);
                    this.screenList = [];
                    res.items.forEach((element: ScreenForList) => {
                        element.fAs.forEach((face: FaceMap) => {
                            face.selected = false;
                        });
                        this.screenList.push(element);
                    });
                    if (
                        localStorage.getItem('selectedFace') != null &&
                        localStorage.getItem('selectedFace') !== ''
                    ) {
                        this.checkIfFaceSelected();
                    }
                    this.total$ = res.total;
                    this.isScreenListLoading = false;
                },
                error: (err: HttpErrorResponse) => {
                    this.waiting$.end(waitingId);
                    console.error(err);

                    this.alert$.show({
                        message: 'Erreur lors de la récupération des écrans',
                        duration: this.errorSnackDurationMs,
                    });

                    this.isScreenListLoading = false;
                },
            });
    }

    /**
     *  Appelé au click sur le bouton de Sélection de l'écran
     *
     * @param selectedFaceFromList Infos de l'écran/Face sélectionnés
     */
    clickScreenFromMap(selectedFaceFromList: SelectFaceFromMapOutput): void {

        selectedFaceFromList.face.selected =
            !selectedFaceFromList.face.selected;

        document
            .getElementById(`marker${selectedFaceFromList.screenItem.i}`)
            .click();

        this.handleFaceSelection(
            selectedFaceFromList.face,
            selectedFaceFromList.screenItem
        );

        // Maj de locationInformation
        this.locationInformation?.fAs.forEach((locationFace: FaceMap) => {
            if (locationFace.id === selectedFaceFromList.face.id) {
                locationFace.selected = selectedFaceFromList.face.selected;
            }
        });
        this.checkCanNext();
        this.LoadCartPrice();
    }

    /**
     *
     * Clic sur un écran dans la liste
     *
     * @param screenId Id de l'écran
     * @param mapMarker Marker sélectionné - nullable
     */
    openInfo(screenId: number, mapMarker: MapMarker = null): void {
        if (mapMarker == null) {
            document.getElementById('marker' + screenId).click();
        } else if (this.selectedMapMarker !== mapMarker) {
            if (!this.isMultipleScreenSelection) {
                this.setSelectedMarker(mapMarker, screenId);
            } else {
                this.selectedMapMarker = mapMarker;
            }
        }
        //Already loaded mapMarker
        else if (!this.isMultipleScreenSelection) {
            this.selectedMapMarker.marker.setAnimation(
                google.maps.Animation.BOUNCE
            );

            setTimeout(() => {
                this.selectedMapMarker?.marker?.setAnimation(null);
            }, this.bouncingMarkerTimeoutMs);
        } else {
            this.selectedMapMarker?.marker?.setAnimation(null);
        }
    }

    /**
     * Sélectionne l'écran dans un cas simple (1 sélection) fait bounce l'icone et  le modifie
     *
     * @param mapMarker Marker clicked
     * @param screenId Id de l'écran cliqué
     */
    private setSelectedMarker(mapMarker: MapMarker, screenId: number) {
        const waitingId: string = this.waiting$.start();

        this.selectedMapMarker?.marker?.setAnimation(null);
        this.selectedMapMarker = mapMarker;
        this.selectedMapMarker.marker.setAnimation(
            google.maps.Animation.BOUNCE
        );

        setTimeout(() => {
            this.selectedMapMarker?.marker?.setAnimation(null);
        }, this.bouncingMarkerTimeoutMs);

        let currentFaceId: number = null;
        let usedLon: number = this.userLon;
        let usedLat: number = this.userLat;
        if (this.addressLat != null && this.addressLng != null) {
            usedLon = this.addressLng;
            usedLat = this.addressLat;
        }

        this.screen$
            .getScreenInfo(screenId, usedLat, usedLon, {
                startDate: this.startDate.value,
                endDate: this.endDate.value,
            })
            .subscribe({
                next: (screenInfos: ScreenForList) => {
                    this.waiting$.end(waitingId);
                    if (this.locationInformation?.i !== screenInfos.i) {
                        this.locationInformation = screenInfos;
                        this.locationInformation.fAs.forEach(
                            (currentFace: FaceMap) => {
                                currentFace.selected =
                                    this.selectedFaceIds.indexOf(
                                        currentFace.id
                                    ) !== -1;

                                currentFaceId = currentFace.id;
                            }
                        );

                        const elementDom: HTMLElement = document.getElementById(
                            currentFaceId.toString()
                        );

                        elementDom.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest',
                            inline: 'nearest',
                        });
                        setTimeout(function () {
                            elementDom.focus();
                        }, 500);
                        setTimeout(function () {
                            elementDom.blur();
                        }, 3000);
                        this.map.panTo(mapMarker.getPosition());

                        this.mapOptions.zoom = 12;
                    }
                },
                error: (err: HttpErrorResponse) => {
                    this.waiting$.end(waitingId);

                    console.error(err);
                },
            });
    }

    /**
     * Appelé au clic sur un pin de la map
     * @param clickedMapMarker Marker de la map cliqué
     * @param screenId *nullable* ScreenId sélectionné
     */
    clickMapMarker(clickedMapMarker: MapMarker, screenId?: number): void {
        if (this.mobile) {
            Crisp.chat.hide();
        }
        if (this.endDate.value?.c != null) {
            this.endDate.setValue(
                DateTime.fromJSDate(new Date(this.endDate.value))
            );
        }
        if (this.startDate.value?.c != null) {
            this.startDate.setValue(
                DateTime.fromJSDate(new Date(this.startDate.value))
            );
        }
        if (
            this.selectedMapMarker !== clickedMapMarker ||
            this.locationInformation == null
        ) {
            //Marker cliqué différent
            this.selectedMapMarker?.marker?.setAnimation(null);
            this.selectedMapMarker = null;
            this.locationInformation = null;
            this.selectedMapMarker = clickedMapMarker;
            this.selectedMapMarker?.marker?.setAnimation(
                google.maps.Animation.BOUNCE
            );

            setTimeout(() => {
                this.selectedMapMarker?.marker?.setAnimation(null);
            }, this.bouncingMarkerTimeoutMs);

            let faceId: number = null;
            let usedLon: number = this.userLon;
            let usedLat: number = this.userLat;
            if (this.addressLat != null && this.addressLng != null) {
                usedLon = this.addressLng;
                usedLat = this.addressLat;
            }
            this.screen$
                .getScreenInfo(screenId, usedLat, usedLon, {
                    startDate: this.startDate.value,
                    endDate: this.endDate.value,
                })
                .subscribe((screenInfos: ScreenForList) => {
                    //Set locationInformation
                    this.locationInformation = screenInfos;
                    this.locationInformation.fAs.forEach((face: FaceMap) => {
                        face.selected =
                            this.selectedFaceIds.indexOf(face.id) !== -1;

                        faceId = face.id;
                    });

                    //Get screenCard in list
                    this.focusFaceOnList(faceId);
                });
        } else {
            this.selectedMapMarker?.marker?.setAnimation(
                google.maps.Animation.BOUNCE
            );

            setTimeout(() => {
                this.selectedMapMarker?.marker?.setAnimation(null);
            }, this.bouncingMarkerTimeoutMs);

            //re-set le focus sur l'élément
            this.focusFaceOnList(this.locationInformation.fAs[0].id);
        }
    }

    /**
     * Focus et recentre dans la liste de gauche la face passée en paramètre
     * @param faceId Id de la face à focus
     */
    private focusFaceOnList(faceId: number) {
        let isHidden: boolean = false;
        document
            .getElementById('screenList')
            .classList.forEach((className: string) => {
                if (className === 'hidden') {
                    isHidden = true;
                }
            });
        if (isHidden) {
            this.reduceScreenList();
        }
        const elementDom: HTMLElement = document.getElementById(
            faceId.toString()
        );

        //Marker dans la liste de gauche ?
        if (elementDom != null) {

            elementDom.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });

            elementDom.setAttribute('tabindex', '-1');
            elementDom.focus();
        } else {
            this.screenList.unshift(this.locationInformation);

            document.getElementById('scrList').scrollTop = 0;

            setTimeout(() => {
                const elementDom: HTMLElement = document.getElementById(
                    faceId.toString()
                );

                elementDom.setAttribute('tabindex', '-1');
                elementDom.focus();
            }, 50);
        }
    }

    /**
     * Méthode appelée par l'infoWindow
     * @param selectedFaceInfos Informations sur la face sélectionnée
     */
    selectFaceFromMap(selectedFaceInfos: SelectFaceFromMapOutput): void {
        //Inversion de la sélection
        selectedFaceInfos.face.selected = !selectedFaceInfos.face.selected;

        // ON enlève ou on supprime la face?
        this.handleFaceSelection(
            selectedFaceInfos.face,
            selectedFaceInfos.screenItem
        );

        // Maj de locationInformation
        this.locationInformation?.fAs.forEach((locationFace: FaceMap) => {
            if (locationFace.id === selectedFaceInfos.face.id) {
                locationFace.selected = selectedFaceInfos.face.selected;
            }
        });

        this.checkCanNext();
    }

    /**
     *
     * Change l'icone et ajoute la face au panier en fonction de la séleciton utilisateur
     *
     * @param mapface Face sélectionnée
     * @param selectedScreen Ecran contenant la face sélectionnée
     * @param selected `true` si la face est sélectionnée
     */
    private handleFaceSelection(
        mapface: FaceMap,
        selectedScreen: ScreenMap
    ): void {
        this.selectedMapMarker?.marker.setIcon(
            this.getIconUrl(
                selectedScreen.sp,
                selectedScreen,
                null,
                mapface.selected
            )
        );

        if (
            this.selectedFaceIds.indexOf(mapface.id) !== 1 &&
            mapface.selected
        ) {
            this.selectedFaceIds.push(mapface.id);
            if (this.window && this.window.dataLayer != null) {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'ecran_ajoute',
                });
                fbq('track', 'ecran_ajoute', {});
            } else {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'ecran_ajoute',
                });
                fbq('track', 'ecran_ajoute', {});
            }
        } else {
            this.selectedFaceIds.splice(
                this.selectedFaceIds.indexOf(mapface.id),
                1
            );
            if (this.window && this.window.dataLayer != null) {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'ecran_supprime',
                });
                fbq('track', 'ecran_supprime', {});
            } else {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'ecran_supprime',
                });
                fbq('track', 'ecran_supprime', {});
            }

            if (!this.isSelectionOK && !this.isMultipleScreenSelection) {
                this.checkForWarnings();
            }


        }

        //ceinture-bretelle on enlève les doublons
        this.selectedFaceIds = [...new Set(this.selectedFaceIds)];

        // Ajout de la face dans le localStorage
        const selectedFaceList: string =
            localStorage.getItem('selectedFace') ?? '';
        let faceIds: number[] =
            selectedFaceList !== ''
                ? selectedFaceList.split(',').map(Number)
                : [];

        if (faceIds.indexOf(mapface.id) === -1) {
            if (mapface.selected) {
                // Ajout dans le localStorage;
                faceIds.push(mapface.id);
                localStorage.setItem('selectedFace', faceIds.join(','));
            }
        } else if (!mapface.selected) {
            // Suppression de la face dans le localStorage;
            faceIds.splice(faceIds.indexOf(mapface.id), 1);
            localStorage.setItem('selectedFace', faceIds.join(','));
        } else {
            //rien
        }

        this.screenList.forEach((screen: ScreenForList) => {
            if (screen.i === selectedScreen.i) {
                //On cherche la bonne face
                screen.fAs.forEach((face: FaceMap) => {
                    if (face.vs === mapface.vs) {
                        face.selected = mapface.selected;
                    }
                });
            }
        });
    }

    private LoadCartPrice() {

        if (!this.startDate.value || !this.endDate.value || (this.startDate.value.toISODate() > this.endDate.value.toISODate())) {
            return;
        }

        // this.cartPriceHT = null;
        this.order$.getCartLight(
            this.selectedFaceIds,
            this.startDate.value.toISODate(),
            this.endDate.value.toISODate(),
            this.campaignName.value,
            10,
            0,
            0).subscribe({
                next: (res: { ht: number }) => {
                    if (res?.ht > 0) {
                        this.cartPriceHT = res.ht;
                    } else {
                        this.cartPriceHT = null;
                    }
                },
                error: (err: HttpErrorResponse) => {
                    console.error("MapComponent - LoadCartLight() : ", err);

                    this.alert$.show({
                        message: "Erreur lors du chargement du prix du panier",
                        duration: 1700
                    });
                }
            });
    }

    /**
     * Ouvre la dialog de récap des écrans sélectionnés
     */
    goToRecap() {
        this.info?.close();
        if (
            this.selectedFaceIds != null &&
            this.selectedFaceIds.length >= 1 &&
            (!this.showRecap || this.showRecap == null)
        ) {
            this.selectedFaceInfo = null;
            let recapFilterParams: InputFilter = JSON.parse(
                JSON.stringify(this.screenFilter)
            );
            recapFilterParams.page = 0;
            recapFilterParams.pageSize = 20;
            recapFilterParams.ONC = true;

            this.showRecap = true;
            setTimeout(() => {
                if (this.mobile && Crisp.isCrispInjected()) {
                    Crisp.chat.hide();
                }
            }, 0);
            const dialogRef = this.dialog.open(SeeSelectedScreenComponent, {
                height: this.mobile ? '100vh' : '',
            });

            dialogRef.componentInstance.recapFilterParams = recapFilterParams;
            dialogRef.componentInstance.selectedFaceIds = this.selectedFaceIds;
            dialogRef.componentInstance.userLat = this.userLat;
            dialogRef.componentInstance.userLon = this.userLon;

            dialogRef.componentInstance.startDate = this.startDate.value;
            dialogRef.componentInstance.endDate = this.endDate.value;

            //ODV hasDateSelected
            dialogRef.componentInstance.hasDateSelected =
                this.startDate.value != null && this.endDate.value != null;

            dialogRef.componentInstance.loadRecap();

            dialogRef.afterClosed().subscribe((result) => {
                this.handleCloseRecap(dialogRef);
            });
        } else {
            this.alert$.show({
                message: 'Aucun écran sélectionné',
                duration: 1000,
            });
        }
    }

    /**
     *
     * @param dialogRef DialogRef du CartDetail
     */
    private handleCloseRecap(dialogRef) {
        Crisp.chat.show();
        this.showRecap = false;

        const listOnclose = dialogRef.componentInstance.screenList;

        if (listOnclose.length <= 0) {
            this.selectedFaceIds = [];
            this.isSelectionOK = true;
        } else {
            const oldSelectection: number[] = this.selectedFaceIds;

            this.selectedFaceIds = this.selectedFaceIds.filter(
                (f) => !dialogRef.componentInstance.faceIdsRemoved.includes(f)
            );

            if (
                oldSelectection.length !== this.selectedFaceIds.length &&
                !this.isSelectionOK
            ) {
                this.checkForWarnings();
            }
        }

        //Reset localStorage
        localStorage.setItem('selectedFace', this.selectedFaceIds.join(','));

        // Update SelectedScreen;
        this.screenList.forEach((sl: ScreenForList) => {
            sl.fAs.forEach((face: FaceMap) => {
                face.selected = false;
                if (this.selectedFaceIds.indexOf(face.id) !== -1) {
                    face.selected = true;
                }
            });
        });

        //Reload map pins
        this.loadScreenMaps(this.endDate.value, this.startDate.value);
        this.checkCanNext();
        this.LoadCartPrice();
    }

    /**
     * Valid la sélection et passe au panier
     */
    next() {
        if (this.canNext) {
            // Stockage des données en local Storage;

            if (this.window && this.window.dataLayer != null) {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'ecrans_selectionnes',
                });
                fbq('track', 'ecrans_selectionnes', {});
            } else {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'ecrans_selectionnes',
                });
                fbq('track', 'ecrans_selectionnes', {});
            }
            this.goToSpotPage();
        } else if (
            this.selectedFaceIds.length <= 0 ||
            this.selectedFaceIds == null
        ) {
            this.alert$.show({
                message: 'Selectionnez au moins un écran',
                duration: 1000,
            });
            return;
        } else if (
            this.campaignName.value === '' ||
            this.campaignName.value == null
        ) {
            this.alert$.show({
                message: 'Donnez un nom à votre campagne',
                duration: 1000,
            });
            this.focusCampaignName();
        } else if (
            this.startDate.value == null ||
            this.startDate.value === ''
        ) {
            this.alert$.show({
                message: 'Saisir une date de début',
                duration: 1000,
            });
            this.focusCampaignDate();
        } else if (this.endDate.value == null || this.endDate.value === '') {
            this.alert$.show({
                message: 'Saisir une date de fin',
                duration: 1000,
            });
            this.focusCampaignDate();
        } else if (this.endDate.value < this.startDate.value) {
            this.alert$.show({
                message: 'Saisir une date de fin antérieure à la date de début',
                duration: 1000,
            });
            // set focus to endDate Item
            document.getElementById('endDate').scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest',
            });
            document.getElementById('endDate').classList.add('mat-focused');
            document.getElementById('endDate').click();
        } else if (!this.isSelectionOK) {
            this.goToRecap();
        } else {
            return;
        }
    }

    /**
     * Défini le focus utilisateur sur le champ du nom de la campagne
     */
    private focusCampaignDate() {
        let eleme = document.getElementById('fakeFormContainer');
        if (eleme.style.display === 'none') {
            this.dateInput.nativeElement.click();
        } else {
            if (this.mobile) {
                this.launchBigForm();
            }
            this.dateInput.nativeElement.click();
        }
    }

    /**
     * Défini le focus utilisateur sur le champ du nom de la campagne
     */
    private focusCampaignName() {
        let eleme = document.getElementById('fakeFormContainer');
        if (eleme.style.display === 'none') {
            this.campaignNameInput.nativeElement.focus();
        } else if (this.mobile) {
            this.launchBigForm();
            this.campaignNameInput.nativeElement.focus();
        } else {
            this.campaignNameInput.nativeElement.focus();
        }
    }

    /**
     * Save le localStorage et redirige vers le panier
     */
    private goToSpotPage() {
        localStorage.setItem('campaignName', this.campaignName.value);
        localStorage.setItem('campaignStartDate', this.startDate.value);
        localStorage.setItem('campaignEndDate', this.endDate.value);
        localStorage.setItem('selectedFace', this.selectedFaceIds.toString());
        this.router.navigateByUrl('/store/spot');
    }

    /**
     * Vérifie si on peut passer au panier
     */
    checkCanNext() {
        this.canNext = false;
        if (this.selectedFaceIds.length === 0 || this.selectedFaceIds == null) {
            this.canNext = false;
            this.nextText = 'Sélectionnez au moins un écran';
        } else if (
            this.campaignName.value === '' ||
            this.campaignName.value == null
        ) {
            this.canNext = false;
            this.nextText = 'Nommer votre campagne';
        } else if (
            this.startDate.value == null ||
            this.startDate.value === ''
        ) {
            this.canNext = false;
            this.nextText = 'Saisir une date de début';
        } else if (this.endDate.value == null || this.endDate.value === '') {
            this.canNext = false;
            this.nextText = 'Saisir une date de fin';
        } else if (this.endDate.value < this.startDate.value) {
            this.canNext = false;
            this.nextText =
                'Saisir une date de fin antérieure à la date de début';
        } else if (!this.isSelectionOK) {
            this.canNext = false;
            this.nextText = 'Des écrans sont indisponibles';
        } else {
            this.canNext = true;
            this.nextText =
                'Continuer avec ' + this.selectedFaceIds.length + ' écran';
            if (this.selectedFaceIds.length > 1) {
                this.nextText = this.nextText + 's';
            }
        }
    }

    /**
     * Défini les face sélectionnées pour l'affichage
     */
    checkIfFaceSelected() {
        if (this.screenList != null && this.screenList.length !== 0) {
            this.screenList.forEach((currentScreen: ScreenForList) => {
                currentScreen.fAs.forEach((currentFace: FaceMap) => {
                    if (this.selectedFaceIds.indexOf(currentFace.id) !== -1) {
                        currentFace.selected = true;
                    }
                });
            });
        }
    }

    /**
     *
     * @param screenParkId Id du parc écran
     * @param selected `true` Si l'écran est sélectionné
     * @returns l'url de l'icone
     */
    getIconUrl(
        screenParkId: number,
        currentScreen: any,
        localStorageSelection?: any,
        selected: boolean = false
    ): string {
        //On charge depuis le localStorage
        if (localStorageSelection != null) {
            currentScreen.atLeastOneSelected = false;
            currentScreen.nfValue = false;


            currentScreen.fAs.forEach((face) => {
                if (localStorageSelection.indexOf(face.id) !== -1) {
                    currentScreen.atLeastOneSelected = true;
                }
                if (face.nf != null && face.nf.length !== 0) {
                    currentScreen.nfValue = true;


                }
            });

            if (currentScreen.atLeastOneSelected) {
                let everyFaceHasSameValue: boolean = currentScreen.fAs.every(
                    (face) => localStorageSelection.indexOf(face.id) !== -1
                );

                if (screenParkId !== 14) {
                    //park Wancom
                    if (everyFaceHasSameValue) {
                        return this.PinkFilledMkr;
                    } else if (currentScreen.nfValue) {
                        return this.PinkFilledAndInactiveHalfMkr;
                    } else {
                        return this.PinkHalfFilledMkr;
                    }

                    // return everyFaceHasSameValue
                    //     ? this.PinkFilledMkr
                    //     : this.PinkHalfFilledMkr;
                } else {
                    //Autres
                    return everyFaceHasSameValue
                        ? this.BlueFilledMkr
                        : this.BlueHalfFilledMkr;
                }
            } else if (!currentScreen.ic || currentScreen.nfValue) {
                return this.InactiveStrokedMkr;
            } else if (screenParkId !== 14) {
                //park Wancom
                return this.PinkStrokedMkr;
            } else {
                //Autres
                return this.BlueStrokedMkr;
            }
        } else {
            //On charge au clic
            let screenNotCompatible: boolean = false;

            //Si tout l'écran est inactif
            if (currentScreen.ic === false) {
                screenNotCompatible = true;
            }

            let everyFaceInactive: boolean = currentScreen.fAs.every(
                (face) => face.nf != null && face.nf?.length !== 0
            );

            let otherFaces: boolean = false;
            currentScreen.fAs.forEach((face) => {
                if (face.nf != null && face.nf?.length !== 0) {
                    otherFaces = true;
                }
            });

            let everyFaceHasSameValue: boolean = true;

            everyFaceHasSameValue = currentScreen.fAs.every(
                (face) => face.selected === currentScreen.fAs[0].selected
            );

            if (screenNotCompatible || everyFaceInactive) {
                return this.InactiveStrokedMkr;
            } else if (screenParkId !== 14) {
                //park Wancom

                if (selected) {
                    if (everyFaceHasSameValue) {
                        return this.PinkFilledMkr;
                    } else {
                        //Check other face
                        return otherFaces
                            ? this.PinkFilledAndInactiveHalfMkr
                            : this.PinkHalfFilledMkr;
                    }
                } else {
                    return everyFaceHasSameValue
                        ? this.PinkStrokedMkr
                        : this.PinkHalfFilledMkr;
                }
            } else if (selected) {
                //Autres parc
                return everyFaceHasSameValue
                    ? this.BlueFilledMkr
                    : this.BlueHalfFilledMkr;
            } else {
                return everyFaceHasSameValue
                    ? this.BlueStrokedMkr
                    : this.BlueHalfFilledMkr;
            }
        }
    }

    /**
     * Récupère la liste des écrans en fonction de la position sur la map
     *
     * @param fromMap Si = `true`, set la localisation recherchée en 'Selon Carte'
     */
    onDrag(fromMap?: boolean) {
        if (fromMap) {
            this.locationSearch.setValue('Selon carte');
        }
        let currentCenter = this.map?.getCenter();
        let currentLat = currentCenter?.lat();
        let currentLng = currentCenter?.lng();

        // Recharger la liste des écrans avec la nouvelle localisation
        //Get screen for screenList
        this.screenFilter.page = 0;

        const waitingId: string = this.waiting$.start();
        this.screen$
            .getScreenList(currentLat, currentLng, null, this.screenFilter, {
                startDate: this.startDate.value,
                endDate: this.endDate.value,
            })
            .subscribe({
                next: (res: FilterResult<ScreenForList>) => {
                    this.screenList = [];
                    res.items.forEach((element: ScreenForList) => {
                        element.fAs.forEach((face: FaceMap) => {
                            face.selected = false;
                        });
                        this.screenList.push(element);
                    });
                    this.checkIfFaceSelected();
                    // this.checkForWarnings();
                    this.waiting$.end(waitingId);
                },
                error: (err: HttpErrorResponse) => {
                    this.waiting$.end(waitingId);

                    this.alert$.show({
                        message: 'Erreur lors de la récupération des écrans',
                        duration: this.errorSnackDurationMs,
                    });

                    console.error(err);
                },
            });
    }

    /**
     * Vérifie si les écrans sélectionnés sont OK et l'actuivité du compte OK
     */
    private checkForWarnings() {
        if (this.selectedFaceIds?.length > 0) {
            this.screen$
                .checkScreenSelection(this.selectedFaceIds, {
                    startDate: this.startDate.value,
                    endDate: this.endDate.value,
                })
                .subscribe({
                    next: (isWarning: boolean) => {
                        this.isSelectionOK = !isWarning;
                        this.checkCanNext();
                    },
                    error: (err: HttpErrorResponse) => {
                        console.error(err);

                        this.alert$.show({
                            message:
                                'Erreur lors de la vérification des écrans sélectionnés',
                            duration: this.errorSnackDurationMs,
                        });
                    },
                });
        } else {
            this.isSelectionOK = true;
        }
    }

    /**
     * Lève le warning et le remonte dans la liste
     * @param screenToMark Ecran à marquer
     * @param faceToMark *nullable* Face à marquer
     */
    private triggerScreenWarning(
        screenToMark: ScreenForList,
        faceToMark?: FaceMap
    ) {
        this.isSelectionOK = false;
        // this.info.close();

        if (faceToMark != null) {
            faceToMark.selected = true;
        }

        let screenFoundInList: ScreenForList = this.screenList.find(
            (s: ScreenForList) => s.i === screenToMark.i
        );

        //Ajout de l'écran avec le warning tout en haut de la liste de gauche
        if (screenFoundInList == null) {
            this.screenList.unshift(screenToMark);
        }
    }

    onResize(event) {
        event.preventDefault();
        this.windowHeight = this.window.innerHeight;
        this.resizeWorks();
        this.mobile = this.window.innerWidth <= 900;
    }

    resizeWorks() {
        this.listHeight = this.windowHeight - 310;
    }

    /**
     * Apellée sur le scroll infini de la liste de gauche
     */
    onScroll() {
        let total = 0;
        total = this.total$;
        if (
            !this.alreadyCalled &&
            total / this.screenFilter.pageSize > this.screenFilter.page + 1
        ) {
            this.alreadyCalled = true;

            this.screenFilter.page = this.screenFilter.page + 1;

            this.screen$
                .getScreenList(
                    this.userLat,
                    this.userLon,
                    null,
                    this.screenFilter,
                    {
                        startDate: this.startDate.value,
                        endDate: this.endDate.value,
                    }
                )
                .subscribe((s) => {
                    this.alreadyCalled = false;

                    s.items.forEach((i) => {
                        this.screenList.push(i);
                    });
                });
        }
    }

    selectedPlace(places) {
        this.google.reverse(places).subscribe((res: any) => {
            let result = res.results[0].geometry.location;
            // set map to new Position
            this.addressLat = result.lat;
            this.addressLng = result.lng;

            this.setMapPosition(result.lat, result.lng);
        });
    }

    /**
     * Défini la postion de la map et  recharge les points
     * @param lat Latitude
     * @param lng Longitue
     */
    private setMapPosition(lat: number, lng: number) {
        let newCenter = { lat: lat, lng: lng };
        this.center = newCenter;
        this.mapOptions.zoom = 10;
        this.screenFilter.page = 0;
        this.screen$
            .getScreenList(lat, lng, null, this.screenFilter, {
                startDate: this.startDate.value,
                endDate: this.endDate.value,
            })
            .subscribe((res: FilterResult<ScreenForList>) => {
                this.screenList = [];
                res.items.forEach((element: ScreenForList) => {
                    element.fAs.forEach((face: FaceMap) => {
                        face.selected = false;
                    });
                    this.screenList.push(element);
                });
                this.checkIfFaceSelected();
            });
    }

    reduceScreenList() {
        let element = document.getElementById('screenList');
        let className = element.classList;
        let isHidden = false;
        className.forEach((className) => {
            if (className === 'hidden') {
                isHidden = true;
            }
        });
        if (isHidden) {
            element.classList.remove('hidden');
        } else {
            element.classList.add('hidden');
        }

        let map = document.getElementById('map');
        let mapClassName = map.classList;
        let isFullWidth = false;
        mapClassName.forEach((className) => {
            if (className === 'fullWidth') {
                isFullWidth = true;
            }
        });
        if (isFullWidth) {
            map.classList.remove('fullWidth');
        } else {
            map.classList.add('fullWidth');
        }
    }

    dateRangeChange() {
        if (
            this.startDate.value != null &&
            this.endDate.value != null &&
            this.startDate.value < this.endDate.value
        ) {

            this.onDrag();
            this.checkForWarnings();

            let startDate = DateTime.isDateTime(this.startDate.value)
                ? this.startDate.value
                : DateTime.fromJSDate(new Date(this.startDate.value));
            let endDate = null;
            if (this.startDate.value) {
                endDate = DateTime.isDateTime(this.endDate.value)
                    ? this.endDate.value
                    : DateTime.fromJSDate(new Date(this.endDate.value));
            }

            localStorage.setItem('campaignStartDate', startDate.toString());
            localStorage.setItem('campaignEndDate', endDate.toString());


            this.loadScreenMaps(endDate || null, startDate || null);

            if (this.window && this.window.dataLayer != null) {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'dates_saisies',
                });
                fbq('track', 'dates_saisies', {});
            } else {
                this.window.dataLayer = window.dataLayer || [];
                this.window.dataLayer.push({
                    event: 'dates_saisies',
                });
                fbq('track', 'dates_saisies', {});
            }
        }
        this.LoadCartPrice();
        this.checkCanNext();
    }

    /**
     *Charge les icones de la map du store
     * @param endDate *nullable* Date de fin de la campagne
     * @param startDate *nullable* Date de début de la campagne
     */
    loadScreenMaps(endDate?: DateTime, startDate?: DateTime) {
        const waitingId: string = this.waiting$.start();


        this.screen$
            .getScreensMap(
                endDate?.toISODate() || null,
                startDate?.toISODate() || null
            )
            .subscribe({
                next: (mapScreens: ScreenMap[]): void => {
                    this.markers = [];


                    mapScreens.forEach((currentScreen: ScreenMap): void => {
                        const newMarker: MarkerItem = {
                            i: currentScreen.i,
                            fAs: currentScreen.fAs,
                            la: currentScreen.la,
                            lo: currentScreen.lo,
                            ic: currentScreen.ic,
                            option: {
                                icon: this.getIconUrl(
                                    currentScreen.sp,
                                    currentScreen,
                                    localStorage
                                        .getItem('selectedFace')
                                        ?.split(',')
                                        .map(Number)
                                ),
                                zIndex: currentScreen.sp !== 14 ? 2 : 1,
                            },
                            sp: currentScreen.sp,
                            position: {
                                lat: currentScreen.la,
                                lng: currentScreen.lo,
                            },
                        };
                        this.markers.push(newMarker);
                    });
                    this.waiting$.end(waitingId);
                },
                error: (err: HttpErrorResponse) => {
                    console.error(err);
                    this.alert$.show({
                        message: 'Erreur lors du chargement de la carte',
                        duration: this.errorSnackDurationMs,
                    });

                    this.waiting$.end(waitingId);
                },
            });
    }

    /**
     * Sur mobile Ouvre en grand les champs de la campagne
     */
    launchBigForm() {
        Crisp.chat.close();
        Crisp.chat.hide();
        this.locationInformation = null;
        document.getElementById('fakeFormContainer').style.display = 'none';
        let elements: any = document.getElementsByClassName('hiddenFormField');
        for (let hri = 0; hri < elements.length; hri++) {
            elements[hri].style = 'display: inline-block';
        }

        document
            .getElementById('topFormContainer')
            .classList.add('bigFormContainer');
        document.getElementById('closeBigForm').style.display = 'flex';
        document.getElementById('bigFormTitle').style.display = 'block';
    }

    /**
     * Sur mobile, Ferme les champs de la campagne
     */
    closeBigForm() {
        if (this.locationInformation == null) {
            Crisp.chat.show();
        } else {
            Crisp.chat.hide();
        }
        document.getElementById('fakeFormContainer').style.display =
            'inline-flex';
        let elements: any = document.getElementsByClassName('hiddenFormField');

        for (let hri = 0; hri < elements.length; hri++) {
            elements[hri].style = 'display: none';
        }

        document
            .getElementById('topFormContainer')
            .classList.remove('bigFormContainer');
        document.getElementById('bigFormTitle').style.display = 'none';
        document.getElementById('closeBigForm').style.display = 'none';
    }

    /**
     * Sélectionne tous les écrans visible sur le zoom actuel de la map
     *
     * @param screenPark Numéro du parkId
     * @param [faceSelection=true] Boolean de sélection des faces
     */
    public SelectScreenInZone(
        screenPark?: number,
        faceSelection: boolean = true
    ) {
        this.isMultipleScreenSelection = true;

        /**
         * Liste des markers à sélectionner
         */
        const markersInBounds: MarkerItem[] =
            this.getMarkersInScreenBounds(screenPark);

        /**
         * Compteur du nombre de face ajoutées
         */
        let nbFaceAdded: number = 0;

        markersInBounds.forEach((currentMarkerInBounds: MarkerItem) => {
            const exisitingScreen: ScreenForList = this.screenList.find(
                (currentScreen: ScreenForList) => {
                    return currentScreen.i === currentMarkerInBounds.i;
                }
            );

            //L'écran est dans la liste de gauche ?
            if (exisitingScreen == null) {
                currentMarkerInBounds.fAs.forEach((currentFace: FaceMap) => {
                    nbFaceAdded = this.handleMultipleSelectionFace(
                        currentFace,
                        currentMarkerInBounds,
                        nbFaceAdded,
                        faceSelection
                    );
                });
            } else {
                exisitingScreen.fAs.forEach((currentFace: FaceMap) => {
                    nbFaceAdded = this.handleMultipleSelectionFace(
                        currentFace,
                        exisitingScreen,
                        nbFaceAdded,
                        faceSelection
                    );
                });
            }
        });

        this.isMultipleScreenSelection = false;
        if (nbFaceAdded > 1) {
            this.alert$.show({
                message: `${nbFaceAdded} Ecrans ont étés ${faceSelection ? 'ajoutés' : 'retirés'
                    } !`,
                duration: 700,
            });
        }
        this.checkForWarnings();
        this.LoadCartPrice();
    }

    /**
     * Gère l'ajout d'une face dans le cas d'une sélection multiple
     *
     * @param faceToSelect Face courant Séléctionnée
     * @param screenSelected ScreenMap sélectionné
     * @param nbFaceAdded Compteur de face ajoutées à incrémenter au cas où
     * @param [faceSelection=true] Boolean de sélection des faces
     * @returns nbFaceAdded incrémenté (ou non)
     */
    private handleMultipleSelectionFace(
        faceToSelect: FaceMap,
        screenSelected: ScreenMap,
        nbFaceAdded: number,
        faceSelection: boolean = true
    ): number {
        //Si la face/l'écran est compatible
        if (
            faceToSelect.selected !== faceSelection &&
            screenSelected.ic === true &&
            (faceToSelect.nf == null || faceToSelect.nf?.length <= 0)
        ) {
            faceToSelect.selected = faceSelection;

            document.getElementById(`marker${screenSelected.i}`).click();

            this.handleFaceSelection(faceToSelect, screenSelected);

            // Maj de locationInformation
            this.locationInformation?.fAs.forEach((locationFace: FaceMap) => {
                if (locationFace.id === faceToSelect.id) {
                    locationFace.selected = faceToSelect.selected;
                }
            });

            nbFaceAdded++;
        }
        return nbFaceAdded;
    }

    /**
     * @param screenPark - *nullable* Numéro du parkId a sélectionné, si null, sélectionne tout
     * @returns `MarkerItem[]` la liste des points affichés à l'écran
     */
    private getMarkersInScreenBounds(screenPark?: number): MarkerItem[] {
        /**
         * Liste des markers actuellement visibles sur la map
         */
        let markersInBounds: MarkerItem[] = [];

        const currentBounds: google.maps.LatLngBounds = this.map.getBounds();
        this.markers.forEach((currentMarkerItem: MarkerItem) => {
            const latLng = new LatLng(
                currentMarkerItem.la,
                currentMarkerItem.lo
            );

            if (currentBounds.contains(latLng)) {
                markersInBounds.push(currentMarkerItem);
            }
        });

        if (screenPark != null) {
            markersInBounds = markersInBounds.filter((mk) => {
                return mk.sp === screenPark;
            });
        }

        return markersInBounds;
    }

    showPicker(event: any) {
        document.getElementById('datePickerToggle').click();
    }

    closePopup() {
        this.selectedMapMarker?.marker?.setAnimation(null);
        this.locationInformation = null;
        if (this.mobile) {
            Crisp.chat.show();
        }
    }

    moveZoom(more: boolean) {
        let currentZoom = this.mapOptions.zoom;
        if (more) {
            currentZoom = currentZoom + 1;
        } else {
            currentZoom = currentZoom - 1;
        }
        this.mapOptions.zoom = currentZoom;
    }
}
